import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InsertPlanReviewCategoryMutationVariables = Types.Exact<{
  object: Types.Plan_Review_Categories_Insert_Input;
}>;


export type InsertPlanReviewCategoryMutation = { __typename?: 'mutation_root', insert_plan_review_categories_one?: { __typename?: 'plan_review_categories', id: any } | null };


export const InsertPlanReviewCategoryDocument = gql`
    mutation insertPlanReviewCategory($object: plan_review_categories_insert_input!) {
  insert_plan_review_categories_one(object: $object) {
    id
  }
}
    `;
export type InsertPlanReviewCategoryMutationFn = Apollo.MutationFunction<InsertPlanReviewCategoryMutation, InsertPlanReviewCategoryMutationVariables>;

/**
 * __useInsertPlanReviewCategoryMutation__
 *
 * To run a mutation, you first call `useInsertPlanReviewCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertPlanReviewCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertPlanReviewCategoryMutation, { data, loading, error }] = useInsertPlanReviewCategoryMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertPlanReviewCategoryMutation(baseOptions?: Apollo.MutationHookOptions<InsertPlanReviewCategoryMutation, InsertPlanReviewCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertPlanReviewCategoryMutation, InsertPlanReviewCategoryMutationVariables>(InsertPlanReviewCategoryDocument, options);
      }
export type InsertPlanReviewCategoryMutationHookResult = ReturnType<typeof useInsertPlanReviewCategoryMutation>;
export type InsertPlanReviewCategoryMutationResult = Apollo.MutationResult<InsertPlanReviewCategoryMutation>;
export type InsertPlanReviewCategoryMutationOptions = Apollo.BaseMutationOptions<InsertPlanReviewCategoryMutation, InsertPlanReviewCategoryMutationVariables>;